// extracted by mini-css-extract-plugin
export default {"privacyPopup":"privacyPopup___fa1b72901adb60d90774","content":"content___a9d0f6b71b52df5431e2"};